var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.861 76.844c-.098-.107-.195-.213-.291-.313l-.043-.043c-1.307-1.346-2.58-2.211-3.734-2.758-1.863-.932-3.705-1.217-5.164-.719l-.072.018-3.287-3.926-16.424-19.617V39.454c.658-1.199 1.02-2.626 1.02-4.162v-8.98c0-3.541-1.904-6.513-5.01-7.394 1.591-.792 2.701-2.555 2.701-4.607 0-2.791-2.051-5.054-4.577-5.054-2.528 0-4.578 2.263-4.578 5.054 0 2.03 1.086 3.776 2.65 4.581-.35.093-.689.205-1.009.35l-13.619 3.456-8.586-10.258a1.441 1.441 0 0 0-2.21 1.849l21.333 25.485v28.609c-23.266.322-37.357 2.762-37.357 5.727 0 3.184 16.854 5.764 42.579 5.764 8.206 0 15.911-.264 22.606-.723-.172-1.352-.15-2.906.506-4.08l-5.16-6.281a340.162 340.162 0 0 0-11.289-.383V53.973l17.563 20.98s-.953 1.379-.48 4.117l.029-.004c.34 2.09 1.383 4.42 3.076 6.553 3.561 4.482 8.627 6.383 11.316 4.248 2.686-2.135 1.98-7.498-1.58-11.98a18.106 18.106 0 0 0-.909-1.043zM50.384 42.959l-.02-.024.02-.001v.025zm-7.305-18.252a9.47 9.47 0 0 0-.138 1.605v7.754l-6.439-7.691 6.577-1.668zm7.305 43.643c-.32-.002-.639-.004-.96-.004V46.3l.96 1.147V68.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.453 69.191l2.502 2.816c5.248-.822 9.176 3.43 10.758 5.516 5.688-.957 7.051-2.135 7.051-3.414 0-2.082-6.93-3.908-20.311-4.918z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoko);
export default __webpack_public_path__ + "static/media/MOKO.0856a1b867665aed2f8e595d6e42f0a2.svg";
export { ForwardRef as ReactComponent };